export default __webpack_public_path__ + "static/media/f6dc383c34ffb2935ff4fc5c515505f4.svg";